import { render, staticRenderFns } from "./main_second.vue?vue&type=template&id=20f57479&scoped=true&"
import script from "./main_second.vue?vue&type=script&lang=js&"
export * from "./main_second.vue?vue&type=script&lang=js&"
import style0 from "./main_second.vue?vue&type=style&index=0&id=20f57479&scoped=true&lang=less&"
import style1 from "./main_second.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f57479",
  null
  
)

export default component.exports